export default {
    state: {
      adminInfo: {},
      addAdminLoading: false,
      addAdminSuccess: false,
      addAdminError: false,
      appStatuses: [],
    },
  };